export const systemColors = {
  default: "rgba(0,0,0,0.91)",
  neutral: "rgb(64 64 64)",
  slate900: "rgb(15 23 42)",
  lime: "rgb(190 242 100)",
  slate600: "rgb(71 85 105)",
};
